import { IDotXetChungChiActionTypes } from "../../action-types/xet-chung-chi/IDotXetChungChiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDotXetChungChiReducer } from "../../reducer-model/xet-chung-chi/IDotXetChungChiReducer";

const iniState: IDotXetChungChiReducer = {
    status: eReducerStatusBase.is_not_initialization,
    dotXetChungChis: [],
}

export const dotXetChungChiReducer = (state: IDotXetChungChiReducer = iniState, action: IDotXetChungChiActionTypes): IDotXetChungChiReducer => {
    switch (action.type) {
        case "DOT_XET_CHUNG_CHI_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "DOT_XET_CHUNG_CHI_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                dotXetChungChis: action.payload
            };
        case "DOT_XET_CHUNG_CHI_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "DOT_XET_CHUNG_CHI_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DOT_XET_CHUNG_CHI_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "DOT_XET_CHUNG_CHI_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DOT_XET_CHUNG_CHI_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "DOT_XET_CHUNG_CHI_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DOT_XET_CHUNG_CHI_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DOT_XET_CHUNG_CHI_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                dotXetChungChiEdit: action.payload,
            };
        case "DOT_XET_CHUNG_CHI_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
                dotXetChungChiEdit: null,
            };
        case "DOT_XET_CHUNG_CHI_SHOW_THAM_SO_MODAL":
            return {
                ...state,
                isShowThamSoModal: true,
                thamSoXetChungChiIdDotXet: action.payload
            };
        case "DOT_XET_CHUNG_CHI_CLOSE_THAM_SO_MODAL":
            return {
                ...state,
                isShowThamSoModal: false,
                thamSoXetChungChiIdDotXet: 0
            };
        
        default:
            return state;
    }
}